module.exports = __webpack_public_path__ + "assets/img/tabs2.44686017.png";